var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 280,
    height: 270,
    viewBox: "0 0 280 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-No_document"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 270
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_document",
    "data-name": "No document",
    clipPath: "url(#clip-No_document)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(-960.437 -1674.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(960.437 1675.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1993",
    "data-name": "Rectangle 1993",
    width: 173.303,
    height: 212.394,
    transform: "translate(0.001 0)",
    fill: "#f4f8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1997",
    "data-name": "Rectangle 1997",
    width: 55.41,
    height: 4.481,
    rx: 2.241,
    transform: "translate(25.261 80.243)",
    fill: "#ececf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    "data-name": "Rectangle 2005",
    width: 129.083,
    height: 9.038,
    rx: 4.519,
    transform: "translate(22.027 39.229)",
    fill: "#ececf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2001",
    "data-name": "Rectangle 2001",
    width: 11.287,
    height: 4.481,
    rx: 2.241,
    transform: "translate(139.259 80.243)",
    fill: "#ececf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1998",
    "data-name": "Rectangle 1998",
    width: 55.41,
    height: 4.481,
    rx: 2.241,
    transform: "translate(25.261 102.809)",
    fill: "#ececf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 55.41,
    height: 4.481,
    rx: 2.241,
    transform: "translate(25.261 125.778)",
    fill: "#ececf0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    width: 55.41,
    height: 4.481,
    rx: 2.241,
    transform: "translate(25.261 147.202)",
    fill: "#ececf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M1416.331,295.3v51.877h25.232C1440.451,347.184,1417.852,321.365,1416.331,295.3Z",
    transform: "translate(-1416.331 -135.016)",
    fill: "#dddde0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M1444.79,321.5a46.784,46.784,0,0,1-17.082-8.79,31.127,31.127,0,0,1-11.377-22.153v3.39c1.521,26.064,24.12,52.094,25.232,52.088a8.293,8.293,0,0,1-1.733-5.214C1439.693,336.019,1442.262,329.446,1444.79,321.5Z",
    transform: "translate(-1416.331 -133.876)",
    fill: "#ececf0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "outline-search-24px_7_",
    "data-name": "outline-search-24px (7)",
    transform: "translate(1023.793 1727.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M0,0H216.207V216.207H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M115.608,102.095h-7.117l-2.522-2.432a58.645,58.645,0,1,0-6.306,6.306l2.432,2.522v7.117l45.043,44.953,13.423-13.423Zm-54.052,0a40.539,40.539,0,1,1,40.539-40.539A40.485,40.485,0,0,1,61.556,102.095Z",
    transform: "translate(26.026 26.026)",
    fill: "#dde8ef"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocument);
export default __webpack_public_path__ + "static/media/no-document.bd9b9f6d.svg";
export { ForwardRef as ReactComponent };